import { Model } from '@vuex-orm/core'
import BookingFee from './BookingFee'
import Configuration from './Configuration'
import { ExtraBreakdown, FeeBreakdown } from './common/breakdown'

export default class TotalPrice extends Model {
  declare id: string
  declare ageGroupID: string
  declare configurationId: string
  declare configuration: Configuration
  declare feeBreakdown: FeeBreakdown
  declare extraBreakdown: ExtraBreakdown
  declare extrasAmount: number
  declare feeBreakDowns: BookingFee[] // via Configuration
  declare netPrice: number
  declare taxAmount: number
  declare specialOfferAmount: number
  declare totalPrice: number
  declare paymentPrice: number

  static entity = 'totalPrices'

  static fields() {
    return {
      id: this.uid(),
      ageGroupID: this.attr(null),
      configurationId: this.attr(null),
      configuration: this.belongsTo(Configuration, 'configurationId'),
      feeBreakdown: this.attr(null),
      extraBreakdown: this.attr({}),
      extrasAmount: this.number(0),
      feeBreakDowns: this.hasManyThrough(BookingFee, Configuration, 'totalPriceId', 'configurationId'),
      netPrice: this.number(0),
      taxAmount: this.number(0),
      specialOfferAmount: this.number(0),
      totalPrice: this.number(0),
      paymentPrice: this.number(0)
    }
  }

  get price() {
    return this.netPrice - this.specialOfferAmount
  }

  static mutators() {
    return {
      totalPrice(value: any) {
        return value
      },
      taxAmount(value: any) {
        return value
      },
      netPrice(value: any) {
        return value
      },
      paymentPrice(value: any) {
        return value
      }
    }
  }
}
